import { Paper, Avatar, Grid, TextField, Button } from "@mui/material";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useState, useEffect } from "react";
import { useAuth } from "../components/AuthContext";
import ErrorPaper from "../components/ErrorPaper";
import InfoPaper from "../components/InfoPaper";

type User = {
    username: string,
    name: string,
    gravatar: string,
};
const PensieveBaseUri = 'http://api.epensieve.com';

const UserPage = () => {
    const { userId, token } = useAuth()!;
    const [user, setUser] = useState<User>({username:'', name: '', gravatar: ''});
    const [error, setError] = useState<string | null>(null);
    const [info, setInfo] = useState<string | null>(null);

    const url = `${PensieveBaseUri}/users/${encodeURI(userId!)}`;
    
    useEffect(() => {
        fetch(url, {method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((response) => {
            if (!response.ok) {
                throw new Error ('Could not get user details. Try Logging out an in again.');
            }
            return response.json();
        }).then((result) => {
            setUser({
                username: result.username,
                name: result.name || '',
                gravatar: result.gravatar || '',
            });
        }).catch((err) => {
            setError(err.message);
        });
    }, [url, token]);

    const handleSubmit = (evt: any) => {
        evt.preventDefault();
        fetch(url, {method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                name: user.name,
                gravatar: user.gravatar,
            })
        }).then((response) => {
            if (!response.ok || !response.body) {
                throw new Error('Could not update user details. Try Logging out an in again.');
            }

            setInfo('Successfully saved User details.');
            setTimeout(() => { setInfo(null); }, 2000);
        }).catch((err) => {
            setError(err.message);
        });
    };

    const paperStyle = {
        padding: 2, 
        margin:"50px auto",
        width: { lg:500, md:400, sm:300, xs:250 },
        minWidth: { lg:500, md:400, sm:300, xs:250 },
        height: '450',
    };

    return (
        <form onSubmit={handleSubmit}>
            { (error) && <ErrorPaper error={error} /> }
            { (info)  && <InfoPaper  msg={info} /> }
            <Paper elevation={10} sx={paperStyle} >
                <Grid container alignItems={'center'} direction={'column'} spacing={1} textAlign='center' width={'inherit'} >
                    <Grid item>
                        <Avatar> <AccountCircleIcon fontSize="large" /> </Avatar>
                    </Grid>
                    <Grid item>
                        <h2> Update your Information </h2>
                    </Grid>
                    <Grid item width={'inherit'} >
                        <TextField label='Username' value={user?.username} variant='standard' fullWidth required disabled />
                    </Grid>
                    <Grid item width={'inherit'} >
                        <TextField label='Name' value={user?.name} onChange={(evt : any) => {setUser({...user, name: evt.target.value})}} variant='standard' fullWidth />
                    </Grid>
                    <Grid item width={'inherit'} >
                        <TextField label='Gravatar' value={user?.gravatar} onChange={(evt : any) => {setUser({...user, gravatar: evt.target.value})}} variant='standard' fullWidth />
                    </Grid>
                    <Grid item >
                        <Button sx={{marginTop:4}} type='submit' color='primary' variant='contained' fullWidth> Submit Changes </Button>
                    </Grid>
                </Grid>
            </Paper>
        </form>
    );
}

export default UserPage;